import type { RouteObject } from 'react-router'

import { BoardPage } from '@/features/boards/BoardPage'

export const routes: RouteObject[] = [
  { path: 'boards', element: <BoardPage /> },
  // The board's project lives in the URL, so a reload, a bookmark or a link
  // sent to a colleague opens the same board.
  { path: 'boards/:projectKey', element: <BoardPage /> },
]
